module.exports = __webpack_public_path__ + "img/graph-incomes.107b6281.svg";